import { EntityList } from '@/common/entityFramework/entityList/EntityList';
import { ExprUtils } from '@/common/utils/ExprUtils';
import { augInctvFieldDefs } from '@/sc/inctvFieldDefs';
import { useCallback } from 'react';

export const InctvRbtLedgerPymtList = ({ inctvRbtId, pymtId }) => {
  const augRowsReq = useCallback(
    (rowsReq) => {
      if (inctvRbtId) {
        rowsReq.expr = ExprUtils.and(rowsReq.expr, ExprUtils.whereParams('inctvRbtId', inctvRbtId));
      }

      if (pymtId) {
        rowsReq.expr = ExprUtils.and(rowsReq.expr, ExprUtils.whereParams('pymtId', pymtId));
      }
    },
    [inctvRbtId, pymtId],
  );

  return <EntityList entity="INCTV_RBT_LEDGER_PYMT" augRowsReq={augRowsReq} augFieldDefs={augInctvFieldDefs} />;
};
